import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Input,
  Button,
  VStack,
  Text,
  Image,
  HStack,
  Flex,
  Link,
  useBreakpointValue,
} from "@chakra-ui/react";
import { FaLocationArrow } from "react-icons/fa";
import profilePicture from "../assets/images/AvaAvatar.png";
import logo from "../assets/images/logo1.png";
import "@fontsource/bubblegum-sans";
import SettingsMenu from "../components/common/SettingsMenu";
import Translate from "../components/LanguageTranslation/Translate";
import { Helmet } from "react-helmet-async";

const NextAdventure = () => {
  const [userMessage, setUserMessage] = useState("");
  const history = useHistory();

  const handleSubmit = (e) => {
    // localStorage.removeItem("conversation_id");
    e.preventDefault();
    history.push(
      `/ai-travel-planner/chat?message=${encodeURIComponent(userMessage)}&source=main`
    );
  };

  const handleSuggestionClick = (message) => {
    // localStorage.removeItem("conversation_id");
    // localStorage.removeItem("activeTab");
    // localStorage.removeItem("generalInfoAdded");
    setUserMessage(message);
    history.push(
      `/ai-travel-planner/chat?message=${encodeURIComponent(message)}&source=main`
    );
  };

  const suggestions = [
    "Inspire where to go",
    "Find lodging",
    "Find activities",
    "Build an itinerary",
  ];

  const inputWidth = useBreakpointValue({
    base: "50vw",
    sm: "60vw",
    md: "40vw",
  });

  return (
    <>
      <Helmet>
        <title>
          Ask&nbsp;Ava: AI Travel Planner for Your Outdoor Adventures&nbsp;|
          NOMAD360
        </title>
      </Helmet>

      <Box
        h={{ base: "calc(100vh - 64px)", md: "100vh", lg: "100vh" }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="white"
        overflowY="scroll"
      >
        <VStack spacing={6} p={{ base: 2, md: 2, lg: 2 }} w="100%" h="100%">
          <Box
            display="flex"
            w="100%"
            alignItems="center"
            justifyContent="space-between"
            position="relative"
          >
            {/* Centered logo only visible on base (mobile) */}
            <Box display={{ base: "flex", md: "none" }} ml={0}>
              <Link href="/home">
                <Image src={logo} height="23px" />
              </Link>
            </Box>

            {/* SettingsMenu aligned right */}
            <Box>
              <SettingsMenu />
            </Box>
          </Box>

          <Flex align="center" p={4} pb={0}>
            <Image
              src={profilePicture}
              alt="Profile"
              w={{ base: "20", sm: "30", md: "40" }}
              h={{ base: "20", sm: "30", md: "40" }}
              borderRadius="full"
              border="4px solid"
              borderColor="#1A202C"
              objectFit="cover"
              objectPosition="top"
              mr={4}
            />
            <Box>
              <Text
                fontFamily="'Bubblegum Sans', sans-serif"
                fontSize={{ base: "3xl", sm: "5xl", md: "6xl" }}
                fontWeight="bold"
                mb={-4}
                lineHeight="shorter"
              >
                Ask
                {/* <Translate text="Ask" /> */}
              </Text>
              <Text
                fontFamily="'Bubblegum Sans', sans-serif"
                fontSize={{ base: "6xl", md: "12xl", lg: "96px" }}
                fontWeight="bold"
                mt={-4}
                lineHeight="shorter"
              >
                Ava
              </Text>
            </Box>
          </Flex>
          <Text textAlign="center" lineHeight="shorter">
            <Translate text="Don't search, just ask Ava. Your Personal AI Travel Planner." />
          </Text>
          <form onSubmit={handleSubmit}>
            <HStack spacing={4} flexWrap="wrap" justifyContent="center">
              <Input
                placeholder={Translate({
                  text: "Ask me anything....",
                  as: "string",
                })}
                value={userMessage}
                onChange={(e) => setUserMessage(e.target.value)}
                size={{ base: "lg", md: "md", lg: "lg" }}
                borderRadius="xl"
                bg="white"
                w={inputWidth}
              />
              <Button
                type="submit"
                bg="#1A202C"
                size={{ base: "lg", md: "md", lg: "lg" }}
                textColor="white"
                borderRadius="xl"
                transition="transform 0.3s"
                _hover={{
                  transform: "scale(1.1)",
                }}
              >
                <Translate text="Ask" />{" "}
                <FaLocationArrow style={{ marginLeft: "8px" }} />
              </Button>
            </HStack>
          </form>
          <HStack
            spacing={{ base: 2, md: 4, lg: 4 }}
            flexWrap="wrap"
            justifyContent="center"
          >
            {suggestions.map((suggestion, index) => (
              <Button
                key={index}
                bg="#286328"
                textColor="white"
                borderRadius="xl"
                size={{ base: "md", md: "md", lg: "md" }}
                variant="outline"
                onClick={() => handleSuggestionClick(suggestion)}
                m={1}
                transition="transform 0.3s"
                _hover={{
                  transform: "scale(1.1)",
                }}
              >
                <Translate text={suggestion} />
              </Button>
            ))}
          </HStack>
          <VStack w={{ base: "75%", md: "62%", xl: "55%" }}>
            <HStack justify="center" mt={0} ml={8} mr={8}>
              <Text  fontSize={{ base: "xs", md: "sm" }} mb={0}>
                <Translate text="By using this chat, you agree to our" />{" "}
                <Link
                  fontSize={{ base: "xs", md: "sm" }}
                  href="/policies/terms-of-service"
                  textDecoration="underline"
                >
                  <Translate text="Terms of Service" />
                </Link>{" "}
                <Translate text="and" />{" "}
                <Link
                  fontSize={{ base: "xs", md: "sm" }}
                  href="/policies/privacy-policy"
                  textDecoration="underline"
                >
                  <Translate text="Privacy Policy" />
                </Link>
                .
              </Text>
            </HStack>

            <Text
              textAlign="justify"
              lineHeight="shorter"
              fontSize={{ base: "xs", md: "sm" }}
              fontWeight="light"
              color="gray.500"
              mt={4}
            >
              <Translate text="Please note: You will communicate with an assistant that uses artificial intelligence (AI). The information you receive may contain errors. We recommend that you always check prices and travel advice via the provider's website and with official authorities before making a booking. NOMAD360™ does not guarantee the accuracy, completeness or suitability of the information provided and expressly excludes any liability for this." />
            </Text>
          </VStack>
        </VStack>
      </Box>
    </>
  );
};

export default NextAdventure;
